import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { createTheme, MantineProvider } from "@mantine/core";
import { router } from "./utils/routing/app-router";
import { store } from "./redux/store";
import { APIProvider } from '@vis.gl/react-google-maps';
import { THEME_COMPONENTS } from "./utils/helper.utils";
import "@mantine/core/styles.css";
import '@mantine/carousel/styles.css';
import '@mantine/dates/styles.css';
import "./config/axios";
import "./index.css";

const GMAPS_API_KEY = import.meta.env.VITE_GMAPS_API_KEY
const theme = createTheme({
  /** Put your mantine theme override here */
  fontFamily: "Helvetica",
  components: THEME_COMPONENTS  
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <APIProvider apiKey={GMAPS_API_KEY}>
      <MantineProvider theme={theme}>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </MantineProvider>
    </APIProvider>
  </React.StrictMode>
);